import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { BottomNav } from './BottomNav';
import { AppHeader } from './AppHeader';

export const AppShell = () => (
  <div className="min-h-dvh bg-background text-foreground">
    <Sidebar />
    <div className="flex min-h-dvh flex-col lg:ml-64">
      <AppHeader />
      {/* Token unico de container das telas autenticadas. Padding lateral
          16px mobile, 24px tablet, 32px desktop. Telas filhas NAO devem
          aplicar padding horizontal proprio (excecao: ChatConversation,
          que cancela com -mx para mensagens irem ate a borda). */}
      <main className="flex-1 px-4 py-6 md:px-6 lg:px-8 lg:py-8">
        <Outlet />
      </main>
      <BottomNav />
    </div>
  </div>
);
